import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { statusUpdateOrg } from 'services/apiOrg';

const useUpdateOrgStatus = () => {
  const queryClient = useQueryClient();
  const{isPending: isUpdating, isSuccess: isUpdated, mutate: updateOrgStatus}=useMutation({
    mutationFn: statusUpdateOrg,
    onSuccess:(data)=>{
        queryClient.setQueryData(['updatedOrgStatus'])
        toast.success('Status Updated')
        queryClient.invalidateQueries({queryKey:['orgList']})
    },
    onError:(error)=>{
        console.log("Error occurred when updating Org status",error)
                if (error?.data && typeof error.data === 'object') {
                // Display all backend validation errors
                for (const key in error.data) {
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg);
                }
            } else {
                toast.error(error.message || "Something went wrong.");
            }
    }
  })

  return{isUpdating, isUpdated, updateOrgStatus}
}

export default useUpdateOrgStatus